// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__1dmlU","col":"Table_col__18aL-","fulfillmentStatus":"Table_fulfillmentStatus__1dk2f","emailCol":"Table_emailCol__37pYr"};